/**
 * Contains common code for TaskTab store
 */

import { ContainerTabStoreBase } from "DistributedTaskControls/SharedViews/ContainerTabs/ContainerTabStoreBase";

export abstract class TaskTabStoreBase extends ContainerTabStoreBase {
}